import styled from 'styled-components';

export const EmptyGroupWrapper = styled.div`
    border: 1.7px solid rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    height: 250px;
    width: 100%;
    margin: 20px 0;
    position: relative;

    @media (min-width: ${(props) => props.theme.breakpoints.tabletSmall}) {
        height: 325px;
        width: 100%;
        margin: 20px 0;
    }

    img {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 30px;
        width: 140px;
        @media (min-width: ${(props) => props.theme.breakpoints.tabletSmall}) {
            top: 40px;
            width: 180px;
        }
    }

    div:first-of-type {
        color: #ffffff80;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 160px;
        font-size: 16px;
        width: max-content;
        @media (min-width: ${(props) => props.theme.breakpoints.tabletSmall}) {
            top: 210px;
            font-size: 20px;
        }
    }
`;
